import z from 'zod'
import { ERROR_DEFAULT } from 'features/common/core/errors'
import api from 'features/common/transport'
import { Employee } from 'features/authorized/components/portal/components/qr/common/core/entities/employee'
import { Currency } from 'features/common/core/entitites'

const sendCodeResponseSchema = z.object({
    members: z
        .array(
            z.object({
                id: z.number(),
                first_name: z.string(),
                last_name: z.string(),
                birth: z.string().optional(),
                email: z.string(),
                organization_id: z.number(),
                phone: z.string(),
                qr_id: z.number(),
                role: z.string(),
                avatar: z.string().optional(),
                stars_average: z.number(),
                tips_sum: z.array(
                    z.object({
                        currency: z.literal('bgn').or(z.literal('ron')),
                        tips_total: z.number()
                    })
                ).or(z.null())
            }),
        )
        .or(z.null()),
})

const getEmployees = async ({ organizationId, currency }: { organizationId: number, currency: Currency }): Promise<Employee[]> => {
    const res = await api.get(`team/members/organization/${organizationId}`)

    const parseRes = sendCodeResponseSchema.safeParse(await res.json())
    if (parseRes.success) {
        if (parseRes.data.members === null) {
            return []
        }
        return parseRes.data.members.map((e) => {
            let tips = 0

            if (e.tips_sum) {
                const currentCurrencyTips = e.tips_sum.find(ts => ts.currency.toUpperCase() === currency)
                tips = currentCurrencyTips?.tips_total || 0
            }

            return {
                id: e.id,
                firstName: e.first_name,
                lastName: e.last_name,
                birth: e.birth || null,
                email: e.email,
                phone: e.phone,
                organizationId: e.organization_id,
                qrId: e.qr_id,
                role: e.role,
                avatar: e.avatar,
                stars: e.stars_average,
                tips,
            }
        })
    }

    throw new Error(ERROR_DEFAULT)
}

export default getEmployees
